export const ErrorComponent = ({error}) => {
  return <div>An Error Occurred: {error.errorCode}</div>;
}